import {
  THERMAL_WIDTH_MM,
  THERMAL_PADDING_H_MM,
  THERMAL_PADDING_V_MM,
} from "../Thermal/thermalConfig";

/** Shared 72.1mm thermal slip CSS (invoice + payment). */
export const getThermalReceiptStyles = () => `
  @media print {
    @page { size: ${THERMAL_WIDTH_MM}mm auto; margin: 0; }
    html, body { margin: 0 !important; padding: 0 !important; }
    .thermal-receipt {
      width: ${THERMAL_WIDTH_MM}mm !important;
      max-width: ${THERMAL_WIDTH_MM}mm !important;
      padding: ${THERMAL_PADDING_V_MM}mm ${THERMAL_PADDING_H_MM}mm !important;
    }
  }
  .thermal-receipt {
    width: ${THERMAL_WIDTH_MM}mm;
    max-width: ${THERMAL_WIDTH_MM}mm;
    min-width: ${THERMAL_WIDTH_MM}mm;
    padding: ${THERMAL_PADDING_V_MM}mm ${THERMAL_PADDING_H_MM}mm;
    margin: 0 auto;
    background: #fff;
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    line-height: 1.45;
    box-sizing: border-box;
  }
  .thermal-receipt * { box-sizing: border-box; }
  .tr-header-meta {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 4px;
    margin-bottom: 3px;
  }
  .tr-date-top {
    font-size: 11px;
    font-weight: 700;
    line-height: 1.25;
    flex-shrink: 0;
  }
  .tr-header-right {
    flex-shrink: 0;
    text-align: right;
    font-size: 10px;
    line-height: 1.35;
    max-width: 50%;
  }
  .tr-header-right-line {
    font-weight: 700;
    word-break: break-word;
  }
  .tr-header-right-line span { font-weight: 600; }
  .tr-logo-wrap { text-align: center; margin-bottom: 3px; }
  .tr-logo {
    width: 112px;
    height: 112px;
    object-fit: contain;
    margin: 0 auto;
    display: block;
  }
  .tr-shop-title {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 5px;
    letter-spacing: 0.15px;
  }
  .tr-staff-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 4px;
  }
  .tr-staff-col { flex: 1; min-width: 0; }
  .tr-staff-col-right { text-align: right; }
  .tr-staff-label {
    font-size: 11px;
    font-weight: 700;
    line-height: 1.25;
    margin-bottom: 1px;
  }
  .tr-staff-phone {
    font-size: 10px;
    font-weight: 600;
    line-height: 1.3;
    word-break: break-word;
  }
  .tr-dash {
    border: none;
    border-top: 1px dashed #000;
    margin: 5px 0;
    height: 0;
  }
  .tr-solid-thick {
    border: none;
    border-top: 2px solid #000;
    margin: 5px 0;
    height: 0;
  }
  .tr-section-title {
    font-size: 12px;
    font-weight: 700;
    margin: 3px 0 4px;
    letter-spacing: 0.3px;
    text-align: center;
  }
  .tr-customer-row {
    padding: 3px 0;
    border-bottom: 1px solid #000;
    font-size: 11px;
  }
  .tr-customer-label {
    display: flex;
    align-items: center;
    gap: 3px;
    font-weight: 600;
    margin-bottom: 2px;
  }
  .tr-customer-value {
    font-weight: 700;
    line-height: 1.35;
    word-break: break-word;
    padding-left: 13px;
  }
  .tr-pay-row {
    display: flex;
    justify-content: space-between;
    padding: 3px 0;
    border-bottom: 1px solid #000;
    font-size: 11px;
  }
  .tr-pay-row:last-of-type { border-bottom: none; }
  .tr-pay-value { font-weight: 700; }
  .tr-amount-highlight {
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    margin: 6px 0 4px;
    padding: 4px 0;
    border: 2px solid #000;
  }
  .tr-desc-block {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.35;
    margin: 4px 0 2px;
    word-break: break-word;
  }
  .tr-desc-block span { font-weight: 700; }
  .tr-thanks {
    text-align: center;
    font-weight: 700;
    font-size: 12px;
    margin-top: 6px;
    letter-spacing: 0.2px;
  }
`;
